export const hotelInvoiceData = {
  hotel: {
    name: "Sea Shell Resort Goa",
    logo: "/images/seashell-logo.png",
    banner: "/images/hotel-banner.jpg",
    address: "Calangute Beach Road, Bardez, Goa - 403516",
    phone: "+91 832 123 4567",
    website: "www.seashellgoa.com"
  },
  invoiceNumber: "HOT-2026-0912",
  dateIssued: "12-09-2026",
  roomNumber: "304",
  checkIn: "01-09-2026",
  checkOut: "05-09-2026",
  client: {
    name: "Arjun Mehta",
    address: "Flat 12B, Andheri East, Mumbai, Maharashtra - 400069",
    phone: "+91 98765 43210"
  },
  items: [
    { desc: "Deluxe Room Charges", qty: "4 Nights", rate: "4500.00", amount: "18000.00" },
    { desc: "Restaurant Bill", qty: "1", rate: "2350.00", amount: "2350.00" },
    { desc: "Spa Service", qty: "1", rate: "1500.00", amount: "1500.00" }
  ],
  summary: {
    subtotal: "21850.00",
    taxes: "2622.00",
    serviceCharge: "500.00",
    total: "24972.00"
  },
  bank: {
    name: "HDFC Bank",
    accountName: "Sea Shell Resort Goa",
    accountNo: "50200123456789"
  }
};
